<template lang="pug">
ul.links.flex_h.d-none.d-md-none.d-lg-flex(@mouseleave="onNavLeave")
  li(
    v-for="(link, index) in links",
    :key="index",
    :class="[liClass(link), { 'is-open': activeIndex === index }]",
    @mouseenter="onEnter(index)",
    @mouseleave="onLeave"
  )
    // 頂層：有 pageName 用路由、否則用 URL
    span.parent-link {{ link.name }}
    //- router-link.parent-link(
    //-   v-if="link.pageName",
    //-   tag="a",
    //-   :to="{ name: link.pageName }"
    //- ) {{ link.name }}
    //- a.parent-link(v-else-if="link.url", :href="link.url") {{ link.name }}

    // children內有list[]
    .dropdown.compl.flex_h(
      v-if="link.children && link.children.length && hasMega(link)"
    )
      .list(v-for="(cat, cidx) in withList(link)", :key="cidx")
        span.title {{ cat.name }}
        ul.items(v-if="cat.list && cat.list.length")
          li.item(v-for="(item, iidx) in cat.list", :key="iidx")
            a.link(:href="item.url") {{ item.name }}

    // simple
    .dropdown.simple.flex_h(v-else-if="link.children && link.children.length")
      a.simple-link(
        v-for="(child, cidx) in withoutList(link)",
        :key="cidx",
        :href="child.url || '#'",
        :class="{ disabled: !child.url }"
      ) {{ child.name }}
</template>

<script>
export default {
  name: "Links",
  data() {
    return {
      // 控制目前展開的 li index，-1 代表都關閉
      activeIndex: -1,
      hideTimer: null,
      SHOW_DELAY: 0, // dropdown 出現延遲（0 = 立即）
      HIDE_DELAY: 500, // dropdown 關閉延遲（ms，可依喜好調整）

      links: [
        {
          name: "商品櫥窗",
          pageName: "Product",
          children: [
            {
              name: "汽車險",
              list: [
                { name: "強制險", url: "/product/intro/1" },
                { name: "第三人責任險", url: "/product/intro/2" },
                { name: "車體險", url: "/product/intro/3" },
                { name: "竊盜險", url: "/product/intro/4" },
                { name: "超額責任險", url: "/product/intro/5" },
                { name: "乘客體傷責任險", url: "/product/intro/7" },
              ],
            },
            {
              name: "機車險",
              list: [
                { name: "強制險", url: "/product/intro/8" },
                { name: "車體險", url: "/product/intro/9" },
                { name: "竊盜險", url: "/product/intro/10" },
                { name: "第三人責任險", url: "/product/intro/11" },
                { name: "駕駛人傷害險", url: "/product/intro/12" },
                { name: "機車乘客體傷責任險", url: "/product/intro/13" },
              ],
            },
            {
              name: "住宅險",
              list: [
                {
                  name: "住宅火災及地震基本保險",
                  url: "/product/intro/14",
                },
                {
                  name: "住宅火災及地震綜合保險",
                  url: "/product/intro/15",
                },
                {
                  name: "住宅火災及日常生活責任綜合保險",
                  url: "/product/intro/16",
                },
                {
                  name: "居家綜合保險",
                  url: "/product/intro/17",
                },
              ],
            },
            {
              name: "旅遊險",
              list: [
                { name: "旅遊平安險", url: "/product/intro/18" },
                { name: "傷害醫療保險", url: "/product/intro/19" },
                { name: "信用卡綜合保險(玉山銀行)", url: "/product/intro/40" },
                { name: "信用卡綜合保險(遠東商銀)", url: "/product/intro/43" },
              ],
            },
            {
              name: "傷害險",
              list: [
                { name: "新快樂童年", url: "/product/intro/25" },
                { name: "新老來保 PLUS", url: "/product/intro/27" },
                { name: "日日心安3", url: "/product/intro/42" },
              ],
            },
            {
              name: "健康險",
              list: [
                { name: "全心防癌", url: "/product/intro/30" },
                { name: "三高心安保", url: "/product/intro/31" },
              ],
            },
            {
              name: "企業保險",
              list: [
                { name: "商業火險", url: "/product/intro/32" },
                { name: "工程保險", url: "/product/intro/33" },
                { name: "責任保險", url: "/product/intro/34" },
                { name: "海上保險", url: "/product/intro/35" },
              ],
            },
          ],
        },
        {
          name: "客戶服務",
          pageName: "CustomerService",
          children: [
            { name: "理賠服務", url: "/customerservice/claimsettlement" },
            { name: "繳費服務", url: "/customerservice/paymentservice" },
            { name: "損害防阻", url: "/customerservice/damageprevention" },
            { name: "電子保單下載", url: "/customerservice/einsurance" },
            { name: "強制證下載", url: "/customerservice/compulsorylicense" },
            { name: "常見問題", url: "/customerservice/faq" },
            { name: "文件下載", url: "/customerservice/documentdownload" },
            { name: "手譯服務", url: "/customerservice/signlanguage" },
            { name: "多語翻譯服務", url: "/customerservice/multilanguage" },
          ],
        },
        {
          name: "認識我們",
          pageName: "AboutUs",
          children: [
            { name: "公司簡介", url: "/aboutus/profile" },
            { name: "公司治理", url: "/aboutus/governance" },
            { name: "永續發展", url: "/aboutus/socialresponsibility" },
            { name: "公開資訊", url: "/aboutus/publicinfo" },
            { name: "最新消息", url: "/aboutus/news" },
            { name: "盡職治理", url: "/customize/Stewardship" },
          ],
        },
        {
          name: "公平待客",
          pageName: "Customize",
          children: [
            { name: "總經理的話", url: "/customize/manager" },
            { name: "關於公平待客", url: "/customize/about" },
            { name: "新安東京海上的公平待客", url: "/customize/clientsfairly" },
            { name: "金融友善服務專區", url: "/customize/financial" },
          ],
        },
      ],
    };
  },
  methods: {
    liClass(link) {
      const rname = (this.$route && this.$route.name) || "";
      const style = this.$store?.state?.navigationStyle;
      let hit = !!(link.pageName && rname.includes(link.pageName));
      
      // Customize 頁面需要根據 Menu 欄位判斷 focus 位置
      if (rname === 'Customize') {
        const menuIndex = this.$store?.state?.customizeMenuIndex ?? 3;
        const currentIndex = this.links.indexOf(link);
        hit = currentIndex === menuIndex;
      }
      
      return {
        selected: hit && style === 1,
        business: hit && style === 2,
        "has-children":
          Array.isArray(link.children) && link.children.length > 0,
      };
    },
    // 有沒有任何 child 帶 list[]
    hasMega(link) {
      return (link.children || []).some(
        (c) => Array.isArray(c.list) && c.list.length > 0
      );
    },
    // 把 children 拆兩組：有 list[] / 沒 list[]
    withList(link) {
      return (link.children || []).filter(
        (c) => Array.isArray(c.list) && c.list.length > 0
      );
    },
    withoutList(link) {
      return (link.children || []).filter(
        (c) => !Array.isArray(c.list) || c.list.length === 0
      );
    },

    // 滑入某個 li：停止關閉計時，立即（或稍微延遲）打開該 dropdown
    onEnter(index) {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
      if (this.SHOW_DELAY === 0) {
        this.activeIndex = index;
      } else {
        setTimeout(() => {
          this.activeIndex = index;
        }, this.SHOW_DELAY);
      }
    },

    // 滑出 li：不要立刻關閉，給一點緩衝
    onLeave() {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
      }
      this.hideTimer = setTimeout(() => {
        this.activeIndex = -1;
        this.hideTimer = null;
      }, this.HIDE_DELAY);
    },

    // 滑出整個 nav 區域（ul.links）時，直接關閉
    onNavLeave() {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
      }
      this.activeIndex = -1;
      this.hideTimer = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/footer/link";

.links > li {
  transition: all 0.5s ease;
}

/* hover 或 is-open（dropdown 展開）時都加底線 & 顏色 */
.links > li:hover,
.links > li.is-open {
  color: #239dd9;
  border-bottom: #239dd9 solid 4px;
}

nav > ul.links {
  position: relative;
  z-index: 30;
}

/* dropdown 本體 */
.dropdown {
  position: absolute;
  top: 100%;
  left: 2.5%;
  width: 95%;
  display: none;
  background: #f9f9fa;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  padding: 24px 48px;
  z-index: 40; /* 高於 overlay */
  opacity: 0;
  transform: translateY(6px);
  transition: opacity 0.12s ease, transform 0.12s ease;
  will-change: opacity, transform;
}

/* is-open 時顯示 dropdown + 動畫 */
li.is-open > .dropdown {
  display: flex;
  opacity: 1;
  transform: translateY(0);
}

/* 全螢幕遮罩（用 clip-path 切掉上方 nav 區域） */
ul.links::after {
  content: "";
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 20;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;
  clip-path: inset(90px 0 0 0); /* 90px 以上不遮，依實際 nav 高度調整 */
}

/* 只要有任一 li.is-open，顯示遮罩 */
ul.links:has(li.is-open)::after {
  opacity: 1;
  pointer-events: auto;
}

.dropdown.compl {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
}

.dropdown.compl .list {
  width: 130px;
  display: flex;
  flex-direction: column;
}

.dropdown.compl .title {
  display: inline-block;
  font-weight: 600;
  font-size: 15px;
  line-height: 1.5;
  color: #009ce5;
  text-decoration: none;
  margin-bottom: 24px;
}

.dropdown.compl .items {
  list-style: none;
  margin: 0;
  padding: 0;
}

.dropdown.compl .item {
  margin-bottom: 12px;
  line-height: 1.5;
}

.dropdown.compl .link {
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  color: #4f4f4f;
  text-decoration: none;
  line-height: 1.5;
}

/* .dropdown.simple */
.dropdown.simple {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.dropdown.simple .simple-link {
  flex: 0 0 calc(100% / 7);
  display: inline-block;
  font-size: 15px;
  line-height: 1.5;
  color: #333;
  text-decoration: none;
  padding: 12px;
}

.links > li:nth-child(4) .simple {
  gap: 48px;
}

.links > li:nth-child(4) .simple-link {
  max-width: 190px;
  flex: 0 0 auto;
}

.dropdown.simple:has(.simple-link:nth-child(n + 8)) {
  justify-content: flex-start;
}

.dropdown.compl .link:hover,
.dropdown.simple .simple-link:hover {
  color: #029ce6;
  text-decoration: underline !important;
  text-underline-offset: 4px;
}

.dropdown.simple .simple-link.disabled {
  pointer-events: none;
  opacity: 0.6;
}

/* 只在「hover 到別的 li」時，取消原本 selected / business 的底線*/
ul.links:has(> li:hover:not(.selected):not(.business)) > li.selected,
ul.links:has(> li:hover:not(.selected):not(.business)) > li.business {
  border-bottom-color: transparent !important;
  color: inherit !important;
}
</style>
